module.exports = __webpack_public_path__ + "img/work07.da9d5a67.png";